<template lang="html">
  <div class="admin-portal-users-container">
    <div>
      <admin-view-users-filters
        @parlay-users-filter-changed="resetFilters"
        @filters="searchAndFilters"
      />
    </div>
    <div>
      <admin-view-users-table
        :loading="loading"
        :usersList="usersList"
        @scroll-on-table="handleScroll(page_number)"
      />
    </div>
    <div class="row w-100 center-xs">
      <div v-if="loading_table_body">
        <pl-spinner class="x5" />
      </div>
    </div>
  </div>
</template>

<script>
  import adminViewUsersFilters from 'features/admin/adminPortal/adminPortalParlay/adminPortalParlayUsers/adminViewUsersFilters.vue';
  import adminViewUsersTable from 'features/admin/adminPortal/adminPortalParlay/adminPortalParlayUsers/adminViewUsersTable.vue';
  import adminServices from 'services/admin/adminServices';
  import { EventBus } from 'utils/event-bus';

  export default {
    components: {
      adminViewUsersFilters,
      adminViewUsersTable,
    },
    data() {
      return {
        user_search: '',
        email_search: '',
        subjects_search: [],
        userType_search: 'teacher',
        userAccountType_search: [],
        loading: false,
        schools_search: [],
        subjectsList: [],
        usersList: [],
        load_more_users: false,
        show_more_users: true,
        page_number: 1,
        loading_table_body: false,
        filters: {
          name: '',
          email: '',
          subjects_ids: [],
          roles: 'teacher',
          schools_ids: [],
          types: 'all',
          page: 1,
          email_domain: '',
        },
      };
    },
    computed: {},
    methods: {
      removeUsersOfSchoolFromTable(usersId) {
        const resultList = this.usersList.filter((u) => {
          return !this.userIsOnTheList(u, usersId);
        });

        this.usersList = resultList;
      },
      userIsOnTheList(u, usersId) {
        if (usersId && usersId.length > 0) {
          return usersId.includes(u.id);
        } else {
          return false;
        }
      },

      getFilteredParlayUsers(page, is_filter, onScroll) {
        if (!onScroll) {
          this.loading = true;
        } else {
          this.loading_table_body = true;
        }

        if (is_filter) {
          this.usersList = [];
        }

        this.filters.page = page;
        this.filters.roles =
          this.filters.roles === 'all' ? null : this.filters.roles;

        adminServices.getFilteredUsersInParlay(this.filters).then(({ data }) => {
          if (data && data.length > 0) {
            this.usersList.push(...data);
            this.page_number += 1;
          } else {
            this.show_more_users = false;
            this.userList = [];
          }
        }).catch((error) => {
          EventBus.$emit('toast-msg', 'Failure. Please try again.' + error);
        }).finally(() => {
          this.loading = false;
          this.loading_table_body = false;
        });
      },
      resetFilters() {
        this.userList = [];
        this.load_more_users = false;
        this.show_more_users = true;
        this.page_number = 1;
      },
      searchAndFilters(filters) {
        this.filters = filters;
        this.getFilteredParlayUsers(this.page_number, true);
      },
      elementHasReachedScrollEnd(elementId) {
        const element = document.getElementById(elementId);

        return (
          element.scrollHeight - Math.floor(element.scrollTop) ===
            element.clientHeight ||
          element.scrollHeight - Math.round(element.scrollTop) ===
            element.clientHeight
        );
      },
      handleScroll(page_number) {
        if (
          this.elementHasReachedScrollEnd('admin-view-users-table') &&
          this.show_more_users
        ) {
          this.getFilteredParlayUsers(page_number, false, true);
        }
      },
    },
    mounted() {
      this.getFilteredParlayUsers(this.page_number, true);

      EventBus.$on('remove-users-of-school-from-table', (usersId) => {
        this.removeUsersOfSchoolFromTable(usersId);
      });
    },
    beforeDestroy() {
      EventBus.$off('remove-users-of-school-from-table');
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .admin-portal-users-container{
    padding: 3.1rem 2rem 0 2rem
  }
</style>



// WEBPACK FOOTER //
// adminViewUsers.vue?225734a3